module.exports = __webpack_public_path__ + "img/auth2.ac911180.png";